import React, { useState, useEffect } from "react";
import PaymentForm from "./Payments Modals/PaymentForm";
import { Column, Row } from "simple-flexbox";
import {
  Paper,
  makeStyles,
  TableBody,
  TableRow,
  TableCell,
  Toolbar,
  InputAdornment,
} from "@material-ui/core";
import useTable from "../../../utilities/useTable";
import { ToastContainer } from "react-toastify";
import StatComponent from "../../stat-page/StatComponent";
import "react-toastify/dist/ReactToastify.css";
import { connect } from "react-redux";
import Controls from "../../../controls/Controls";
import { Search } from "@material-ui/icons";
import AddIcon from "@material-ui/icons/Add";
import Popup from "../../../utilities/Popup";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import PaymentOutlinedIcon from "@material-ui/icons/PaymentOutlined";
import CloseIcon from "@material-ui/icons/Close";
import Notification from "../../../utilities/Notification";
import ConfirmDialog from "../../../utilities/ConfirmDialog";
import AddPaymentForm from "./Payments Modals/AddPaymentForm";
import Button from "@mui/material/Button";
import { Link } from "react-router-dom";
import CreditPaymentForm from "./Payments Modals/CreditPayments";

const useStyles = makeStyles((theme) => ({
  pageContent: {
    margin: theme.spacing(1),
    padding: theme.spacing(3),
  },
  searchInput: {
    width: "75%",
  },
  newButton: {
    position: "absolute",
    right: "10px",
  },
}));

const headCells = [
  { id: "cashRecieved", label: "Cash Recieved" },
  { id: "amountPaid", label: "Outstanding" },
  { id: "paymentTyoe", label: "Payment Type" },
  { id: "customerName", label: "Customer Name" },
  { id: "customerName", label: "Date Paid" },
 
];

export function CreditPayment({
  payments,
  UpdatePayment,
  DeletePayment,
  LoadPayments,
  companyId,
  AddPayment,
  LoadCreditPayments,
  credits,
  categories,
  accounts,
  accountTypes,
  paymentTypes,
  cardTypes,
}) {
  const classes = useStyles();
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [openPopup, setOpenPopup] = useState(false);
  const [addOpenPopup, setAddOpenPopup] = useState(false);
  const [repayPopup, setRepayPopup] = useState(false);

  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(credits, headCells, filterFn);
  console.log("Here is the Credits 😁", credits);
  useEffect(() => {
    LoadCreditPayments("");
    return () => {};
  }, []);

  const handleSearch = (e) => {
    var payload = {
      tranRef: e.target.value,
    };
    LoadCreditPayments(payload);
  };

  const addOrEdit = (payment, resetForm) => {
    var data = { ...payment, companyId: companyId };
    UpdatePayment(data);
    resetForm();
    // setRecordForEdit(null)
    setOpenPopup(false);
    setAddOpenPopup(false);
  };

  const addPayment = (payment, resetForm) => {
    var data = { ...payment, companyId: companyId };
    AddPayment(data);
    resetForm();
    setRecordForEdit(null);
    setOpenPopup(false);
    setAddOpenPopup(false);
  };

  const openInPopup = (item) => {
    setRecordForEdit(item);
    setOpenPopup(true);
  };

  const onDelete = (id) => {
    DeletePayment(id);
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false,
    });
  };
  return (
    <div className="container" style={{ paddingTop: "1rem" }}>
      <Column flexGrow={1}>
        <ToastContainer />
        <div>
          <Controls.Input
            label="Input Transaction Reference to get Subsequent Payments"
            className={classes.searchInput}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search />
                </InputAdornment>
              ),
            }}
            onChange={handleSearch}
          />
        </div>
        <Paper className={classes.pageContent}>
          <div className="grid grid-cols-2">
            <h4>
              {" "}
              <strong>Credit Payments</strong>
            </h4>

            <div className="flex justify-end space-x-7">
              <Link to="/repayments">
                <div className="flex hover:bg-[#92a3f785] hover:transition hover:duration-500 hover:ease-in-out space-x-2 bg-[#7987cb85] px-3 py-2 rounded-full items-center justify-center">
                  {" "}
                  <div className="bg-[#7987cbc7] rounded-full h-8 w-8 text-center items-center justify-center flex">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-5 w-5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="#5865f2"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M10 19l-7-7m0 0l7-7m-7 7h18"
                      />
                    </svg>
                  </div>{" "}
                  <div className="flex items-center">
                    <span className="text-[#5865f2]">Go To Repayments</span>
                  </div>
                </div>
              </Link>

              <CreditPaymentForm />
            </div>
          </div>

          <TblContainer>
            <TblHead />
            <TableBody>
              {recordsAfterPagingAndSorting().map((item) => (
                <TableRow key={item.id}>
                  <TableCell>{item.amountPaid}</TableCell>
                  <TableCell>{item.amountOutstanding}</TableCell>
                  <TableCell>{item.paymentType}</TableCell>
                  <TableCell>{item.name}</TableCell>
                  <TableCell>{item.datePaid}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </TblContainer>
          <TblPagination />
        </Paper>

        <Popup
          title="Repayment Form"
          openPopup={openPopup}
          setOpenPopup={setRepayPopup}
        >
          <CreditPaymentForm setOpenPopup={setOpenPopup} />
        </Popup>

        <Popup
          title="Credit Details"
          openPopup={openPopup}
          setOpenPopup={setOpenPopup}
        >
          <PaymentForm
            recordForEdit={recordForEdit}
            addOrEdit={addOrEdit}
            categories={categories}
            accounts={accounts}
            accountTypes={accountTypes}
            paymentTypes={paymentTypes}
            cardTypes={cardTypes}
          />
        </Popup>

        <Popup
          title="Add Payment Form"
          openPopup={addOpenPopup}
          setOpenPopup={setAddOpenPopup}
        >
          <AddPaymentForm
            recordForEdit={recordForEdit}
            addOrEdit={addPayment}
            categories={categories}
            accounts={accounts}
            accountTypes={accountTypes}
            paymentTypes={paymentTypes}
            cardTypes={cardTypes}
          />
        </Popup>
        <Notification notify={notify} setNotify={setNotify} />
        <ConfirmDialog
          confirmDialog={confirmDialog}
          setConfirmDialog={setConfirmDialog}
        />
      </Column>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    buttonloader: state.utilityReducer.buttonloader,
    payments: state.salesReducer.payments,
    accountTypes: state.salesReducer.accountTypes,
    credits: state.salesReducer.credits,
    accounts: state.salesReducer.accounts,
    paymentTypes: state.salesReducer.paymentTypes,
    cardTypes: state.salesReducer.cardTypes,
  };
}
const mapDispatchToProps = (dispatch) => ({
  AddPayment(payload) {
    dispatch({ type: "ADD_PAYMENT", payload });
  },

  LoadCreditPayments(payload) {
    dispatch({ type: "LOAD_CREDIT_PAYMENT", payload });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(CreditPayment);
